import i18n from "@/i18n";
import { success } from '@/components/common/NotificationPlugin';

export function copyToClipboard(value, message = 'Text copied to clipboard.') {
  const el = document.createElement('textarea');

  el.value = value;

  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  success(i18n.t(message))
}

export default {
  install(Vue) {
    Vue.config.globalProperties.$copyToClipboard = copyToClipboard
  }
}
